import type { Product, CompetitorProduct } from '../../../model';

export type CompetitorMatchedProductsRequest = {
  skus: string[];
  enabled?: boolean;
};

export type CompetitorMatchedProductsResponse = Array<{
  skinSeoulProduct: Product;
  machineMatchedProducts: Array<{
    competitor: string;
    competitorProducts: CompetitorProduct[];
  }>;
  humanMatchedProducts: Array<{
    competitor: string;
    competitorProducts: CompetitorProduct[];
  }>;
  modifiedAt: string;
}>;

export type CompetitorCollectionProductsResponse = {
  products: Product[];
};

export type CompetitorAnalysisRequest = {
  // Define the structure based on usage
  id?: string;
  params?: Record<string, unknown>;
};

export type CompetitorProductsRequest = CompetitorMatchedProductsRequest;

export type MatchedProductsRequest = CompetitorMatchedProductsRequest;
